<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">BL PDF 情報</span>
      </v-card-title>
      <v-card-actions>
        <v-btn v-if="isDialog" @click="save()">保存</v-btn>
        <tdoc-file-upload
          v-if="!cantEdit"
          :disabled="!bl.blNo || !bl.blDate"
          @addAttachment="addAttachment"
          :newFileName="
            $generateAwbFileName(
              this.bl.blNo,
              this.bl.blDate,
              this.bl.attachments
            )
          "
          type="AWB_LIST"
          style="margin:0px 15px;"
          title="BL PDF UPLOAD"
        ></tdoc-file-upload>
        <v-btn v-if="isDialog" @click="back()" small>{{
          $t('app.buttons.back')
        }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-flex class="pa-4">
          <ul class="doc">
            <li v-for="file in bl.attachments" :key="file.fileOssId">
              <div @click="$downloadTdocFile(file)">{{ file.name }}</div>
              <span
                v-if="!cantEdit"
                @click="remove(file)"
                class="material-icons del-btn"
              >
                delete_outline
              </span>
            </li>
          </ul>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: ['bl', 'cantEdit', 'isDialog'],
  methods: {
    save() {
      this.$http
        .put(`/tdoc/bls/${this.bl.id}/valid-md5`, this.bl)
        .then((res) => {
          if (res.data) {
            this.doSave()
          } else {
            this.$message(
              '',
              'BLデータはSAPから上書きされました、検索してから編集お願いします'
            )
          }
        })
        .catch((err) => {
          this.$message('', this.$t('app.system.error'))
        })
    },
    doSave() {
      this.$http
        .put(`tdoc/bls/${this.bl.id}`, {
          ...this.bl,
        })
        .then(() => {
          this.back()
          this.$message('', '保存しました。')
        })
        .catch((err) => {
          if (this.$te(`tdoc.${err.response.data}`)) {
            this.$message('', this.$t(`tdoc.${err.response.data}`))
          } else {
            this.$message('', this.$t('app.system.error'))
          }
        })
    },
    addAttachment(attachment) {
      if (!this.bl.attachments) {
        this.bl.attachments = []
      }
      this.bl.attachments = [...this.bl.attachments, attachment]

      // if (this.bl.id) {
      //   this.$http
      //     .put(`/tdoc/bls/attachments/${this.bl.id}`, attachment)
      //     .then(() => {
      //       this.load()
      //     })
      // }
      // this.bl.attachments = [...this.bl.attachments, attachment]
    },
    remove(file) {
      this.bl.attachments.forEach((attachment, index) => {
        if (attachment.fileOssId === file.fileOssId) {
          this.bl.attachments.splice(index, 1)
        }
      })
      // if (this.isDialog) {
      //   this.$http
      //     .delete(`/tdoc/bls/attachment/${file.id}`)
      //     .then(() => {
      //       this.bl.attachments.forEach((attachment, index) => {
      //         if (attachment.fileOssId === file.fileOssId) {
      //           this.bl.attachments.splice(index, 1)
      //           this.$forceUpdate()
      //           this.$message('', 'BL ファイル削除しました。')
      //         }
      //       })
      //     })
      //     .catch((err) => {
      //       this.$message('', 'BL ファイル削除失敗しました。')
      //     })
      // } else {
      // }
    },
    back() {
      this.$emit('refresh')
      this.$emit('close')
    },
    load() {
      this.$http.get(`tdoc/bls/${this.bl.id}`).then((res) => {
        this.bl = res.data
      })
    },
  },
}
</script>

<style scoped>
.doc {
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 12px;
  padding: 5px 0px;
}

.doc li {
  padding: 0px 15px 0px 25px;
  list-style: none;
  background: transparent url(../../assets/img/pdf.svg) no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
}

.del-btn {
  margin-left: 10px;
  color: #666;
  cursor: pointer;
}
</style>
